export default __webpack_public_path__ + "static/media/wpmtest_locked_crown.e91b4bc2.svg";